<template>
  <div>
    <button @click="show = true" v-if="this.$slots.button != null">
      <slot name="button"></slot>
    </button>

    <modal v-if="active"
      ><modal-inner
        :fullscreen="fullscreen"
        :modalInnerClasses="modalInnerClasses"
      >
        <div
          class="flex justify-center flex-shrink-0 align-middle text-color-regular content-center text-center"
        >
          <h2 class="flex-grow text-chplus-regular mb-4 font-bold self-center">
            <slot name="title"></slot>
          </h2>
        </div>

        <template v-if="this.$slots.content != null">
          <template v-if="fullscreen">
            <content-scroll-container class="flex-1 mb-4 text-chplus-regular">
              <content-scroll-inner
                ><slot name="content"></slot
              ></content-scroll-inner>
            </content-scroll-container>
          </template>
          <template v-else>
            <div class="alert-content mb-4">
              <slot name="content"></slot>
            </div>
          </template>
        </template>

        <div class="my-2 w-full flex flex-row justify-center">
          <slot name="footer">
            <navigate-small-button
              :theme="'contrast-light'"
              :text="$t('components.layouts.alert.button_close')"
              @click="close"
            />
          </slot>
        </div> </modal-inner
    ></modal>
  </div>
</template>

<script>
import Vue from "vue";
import NavigateSmallButton from "@/components/buttons/NavigateSmallButton";
import Modal from "@/components/layouts/Modal";
import ModalInner from "@/components/layouts/ModalInner";
import ContentScrollContainer from "@/components/layouts/ContentScrollContainer";
import ContentScrollInner from "@/components/layouts/ContentScrollInner";

export default {
  name: "Alert",
  components: {
    ContentScrollInner,
    ContentScrollContainer,
    ModalInner,
    Modal,
    NavigateSmallButton
  },
  props: {
    show: {
      type: Boolean
    },
    bus: {
      type: Vue,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    modalInnerClasses: {
      type: String,
      default: ""
    }
  },
  data: () => {
    return {
      active: false
    };
  },
  watch: {
    show(value) {
      this.active = value;
    }
  },
  created() {
    if (this.bus != null) {
      this.bus.$on("click", () => (this.active = true));
    }
  },
  mounted() {
    this.active = this.show;
  },
  methods: {
    close() {
      this.active = false;
      this.$emit("hide");
    }
  }
};
</script>
